import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";

import Client from "../contentful";
import coverbg from '../img/bg-cover-img.jpg';
import CarouselComponent from '../components/carousel';
import location_1 from '../img/location-img-1.jpg';
import location_2 from '../img/location-img-2.jpg';
import location_3 from '../img/location-img-3.jpg';
import our_courses_1 from '../img/our-courses-img-1.jpg';
import our_courses_2  from '../img/our-courses-img-2.jpg';
import parnter_logo_4 from '../img/partner-logo-4.jpg';
import parnter_logo_3 from '../img/partner-logo-3.jpg';
import parnter_logo_5 from '../img/partner-logo-5.jpg';

import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton,NavDropdown , Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'

// const API = "http://localhost:8000/products/products/"
export default class Home extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
            // isLoaded:false,

		   welcometext:[],
		   welcometextless:[],
		   locationtext:[],
		   ourProgramsUndergraduatePicture:"",
		   graduatetext:[],
		   ourProgramsGraduatePicture:"",
		   
		   technologytext:[],
		   ourLocationPictures:[],
		   textInBoxesTechnologycontent:[],
		   partnerUniversitiesImages:[],
		 
		   displayreadmore : false,


		}
		this.readmore = this.readmore.bind(this);
	}
	

	formatData(items) {
        let tempItems = items.map(item => {
    
          let id = item.sys.id;
		 
		  let welcometext = item.fields.welcomeText.content
		  let welcometextless = item.fields.welcomeText.content.slice(0,3)
		 
		  let ourProgramsUndergraduatePicture = item.fields.ourProgramsUndergraduatePicture
		  let ourProgramsGraduatePicture = item.fields.ourProgramsGraduatePicture
		  let graduatetext = item.fields.graduatetext.content
		  let locationtext = item.fields.ourLocationText.content
		
		  let technologytext = item.fields.technologytext.content

		  let textInBoxesTechnologycontent = item.fields.textInBoxesTechonology.items
		  let partnerUniversitiesImages = item.fields.partnerUniversitiesImages
		//   let textInBoxesTechnologyheading = item.fields.textInBoxesTechnology.header
		  this.setState({
			welcometext:welcometext,
			welcometextless:welcometextless,
			graduatetext: graduatetext,
			locationtext:locationtext,
			ourProgramsUndergraduatePicture:ourProgramsUndergraduatePicture,
			ourProgramsGraduatePicture:ourProgramsGraduatePicture,
			technologytext:technologytext,
			textInBoxesTechnologycontent:textInBoxesTechnologycontent,
			partnerUniversitiesImages:partnerUniversitiesImages
			
		})
		console.log(this.state.welcometextless)
		console.log(this.state.welcometext)
		console.log(this.state.textInBoxesTechnologyheading)
		let ourLocationPictures = item.fields.ourLocationPictures
        this.setState({
			ourLocationPictures:ourLocationPictures
		})
    
       
        
          
          
        });
        return tempItems;
        console.log(items)
      }
      
        componentDidMount() {
	  
			
          Client.getEntries({
            content_type : "homePage"
          })
          .then(response=>{
            console.log(response.items)
			this.formatData(response.items)
			const undergraduateText = response.items[0].fields?.undergraduateText
			document.getElementById('rich-text-body').innerHTML = documentToHtmlString(undergraduateText)

			const graduatetext = response.items[0].fields?.graduatetext
			document.getElementById('rich-text-body1').innerHTML = documentToHtmlString(graduatetext)
          })
        }

		

		readmore(){
			
			if(this.state.displayreadmore == false){
			this.setState({
				displayreadmore: true
			})
			}
			else{
				this.setState({
					displayreadmore: false
				})
			}
		}



    render() {
		function mouseenter0() {
        
			const button = document.getElementById('dropdown-basic0')
			button.click()
		  }
	
		  function mouseleave0(){
			const button = document.getElementById('dropdown-basic0')
			button.click()
		  }
		  function mouseenter1() {
			
			const button = document.getElementById('dropdown-basic1')
			button.click()
		  }
	
		  function mouseleave1(){
			const button = document.getElementById('dropdown-basic1')
			button.click()
		  }
	
		  function mouseenter2() {
			
			const button = document.getElementById('dropdown-basic2')
			button.click()
		  }
	
		  function mouseleave2(){
			const button = document.getElementById('dropdown-basic2')
			button.click()
		  }
		  function mouseenter3() {
			
			const button = document.getElementById('dropdown-basic3')
			button.click()
		  }
	
		  function mouseleave3(){
			const button = document.getElementById('dropdown-basic3')
			button.click()
		  }
		  function mouseenter4() {
			
			const button = document.getElementById('dropdown-basic4')
			button.click()
		  }
	
		  function mouseleave4(){
			const button = document.getElementById('dropdown-basic4')
			button.click()
		  }
        return(
            <div>
				<Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px",  marginLeft:"1rem",marginRight:"5rem"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
		  marginRight: "1rem",
		  marginLeft:"10px" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter0} onMouseLeave={mouseleave0}> 
        
       <Dropdown>
  <Dropdown.Toggle variant="bg-light" id="dropdown-basic0" >
  <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item ><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter1} onMouseLeave={mouseleave1}> 
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic1" >
        <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter2} onMouseLeave={mouseleave2}>
         
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic2" >
        <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
		<Dropdown.Item ><Link to="/transfers" style={{color: "black"}}>Transfers</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter3} onMouseLeave={mouseleave3}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic3" >
        <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
        {/* <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter4} onMouseLeave={mouseleave4}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic4" >
        <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
	marginTop: "0.3rem",
	marginLeft:"10px"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar>  
            <CarouselComponent />
            <div class="container mb-5">
        <h2 class="text-center font-w-600 mt-5">Welcome</h2>
		{/* <div className="show-more" onClick={this.readmore}>Read More</div> */}
        <div id="">

	{

	(this.state.displayreadmore == false) ?	(
		<div>
            <div class="text show-more-height">
				{
					this.state.welcometextless.map(item => (
				
            <p>
	{ item?.content[0]?.value }
    </p>
					))
	}

	
    
	
            </div>
			
			<div className="show-more" style={{color: "blue", cursor:"pointer"}} onClick={this.readmore}>Read More</div>
			</div>

	) :  (    
		<div>
            <div class="text show-more-height">
				{
					this.state.welcometext.map(item => (
				
            <p>
	{ item?.content[0]?.value }
    </p>
					))
	}

	
    
	
            </div>
			
			<div className="show-more pointer" style={{color: "blue", cursor:"pointer"}} onClick={this.readmore}>Read Less</div>
			</div>
	   )
	}

            <hr/>



    <div class="row">
		<div class="col-lg-12">
		<h2 class="mt-3 mb-3 font-w-600">Our Location</h2>

		{
					this.state.locationtext.map(item => (
						<p className="mb-4">{item?.content[0]?.value}</p>

					))
	}

			


		</div>

		{
					this.state.ourLocationPictures.map(item => (
		<div class="col-lg-4">
			<div class="location">
				<img src={item?.fields?.file?.url} className="img-fluid ourlocationpictures" alt="" />
			</div>
		</div>

					))
	}


		{/* // <div class="col-lg-4">
		// 	<div class="location">
		// 		<img src={location_2} class="img-fluid " alt="" />
		// 	</div>
		// </div>

		// <div class="col-lg-4">
		// 	<div class="location">
		// 		<img src={location_3} class="img-fluid " alt="" />
		// 	</div>
		// </div>		 */}
	</div>

    </div>
</div>




    <div class="bg-1 p-t-50 p-b-50">
	<div class="container">
		<h2 class="font-w-600">Our Programs</h2>
		<div class="row mt-5 our-programmers">
			<div class="col-lg-6">
			  <div class="card height-100">
			    <img src={this.state.ourProgramsUndergraduatePicture?.fields?.file?.url} class="card-img-top" alt="..." />
			    <div class="card-body">
			      <h4 class="card-title">Undergraduate</h4>
			     


<p className="mb-4"><div id="rich-text-body"></div></p>
<Link to="/academics">
				  <p class="card-text btn-color  mt-2"><i class="fa fa-arrow-right"></i><span class="font-w-600 ml-2">Course Details</span></p></Link>
			    </div>
			  </div>				
			</div>

			<div class="col-lg-6">
			  <div class="card height-100">
			    <img src={this.state.ourProgramsGraduatePicture?.fields?.file?.url} class="card-img-top" alt="..." />
			    <div class="card-body">
			      <h4 class="card-title">Graduate</h4>
			     
				  <p className="mb-4"><div id="rich-text-body1"></div></p>
				  <Link to="/academics">
				  <p class="card-text btn-color mt-3 mb-1"><i class="fa fa-arrow-right"></i><span class="font-w-600 ml-2">Course Details</span></p></Link>
			    </div>
			  </div>				
			</div>
		</div>
	</div>
</div>

<div class="container p-b-50">
	<h2 class="font-w-600 mt-5">Technology</h2>

	<div class="row mt-4">
		<div class="col-lg-12">
	
		{
					this.state.technologytext.map(item => (
						<p className="mb-4">{item?.content[0]?.value}</p>

					))
	}

		</div>
   </div>

	<div class="row mt-5">
	{
					this.state.textInBoxesTechnologycontent.map(item => (	
		<div class="col-lg-4">
		
			<div class="border p-25 technology height-100 bg-2">
				<h4 class="text-center mt-2">{item?.header}</h4>
					<p class="mt-4">{item?.content}</p>
				{/* <!-- <p class="btn-color text-center"><i class="fas fa-arrow-right"></i><span class="font-w-600 ml-2">View All Dates</span></p> --> */}
			</div>
	
		</div>
						))
					}

		{/* <div class="col-lg-4 re-mt-30">
			<div class="border p-25 technology height-100 bg-2">
				<h4 class="text-center mt-2">Collaboration and Connectivity</h4>
				<p class="mt-4">Live classroom technology allows students to work together in groups, present to their peers and become fully immersed in a dynamic learning environment. Studies show that the LIVE classroom technology results in an engagement of over 90%; much higher than face-to-face statistics.</p>
				
			</div>
		</div>

		<div class="col-lg-4 re-mt-30">
			<div class="border p-25 technology height-100 bg-2">
				<h4 class="text-center mt-2">Stay Close, Go Far</h4>
				<p class="mt-4">The quality of the programs offered in this exciting initiative, enable students to remain in Qatar and get a first complete education either in its entirety or as a stepping stone to continuing in the US or UK or in Qatar. Global Studies Institute is committed to bringing students the best educational experience as well as a support network that facilitates student success.</p>
				
			</div>
		</div> */}
	</div>


	<div class="d-flex justify-content-center">
		<Link to="/LiveClassroomTechnology">
      	<button type="button" class="btn btn-primary view-team-btn mt-5">Learn More</button></Link>
      </div>

</div>
<div class="">
	<img src={coverbg} class="img-fluid" alt=""/>
</div>

<div class="container p-b-50">
	<h2 class="font-w-600 mt-5">Partner Universities </h2>
	<div class="row mt-5">
	{
					this.state.partnerUniversitiesImages.map(item => (

		<div class="col partner-universities-logo">
			<a href={'https://www.'+`${item?.fields?.description}`} target="_blank">
			<img src= {item?.fields?.file?.url} class="img-fluid" alt="" />
			</a>
		</div>

					))
	}
		
		{/* <div class="col partner-universities-logo">
			<a href="https://www.sc.edu/" target="_blank">
				<img src={parnter_logo_1} class="img-fluid" />
			</a>
		</div> */}



		{/* <div class="col partner-universities-logo">
			<a href="http://www.astate.edu/" target="_blank">
				<img src={parnter_logo_5} class="img-fluid" alt="" />
			</a>
		</div>

		<div class="col partner-universities-logo">
			<a href="http://web.mit.edu/" target="_blank">
				<img src={parnter_logo_3} class="img-fluid" alt="" />
			</a>
		</div> */}

	</div>
</div>	

            </div>
            
        )
    }
}